import { useContext } from 'react';
import { PostContext } from '../providers/PostProvider';

export const usePost = () => useContext(PostContext);
